import LegalHero from "@/pages/legal/components/LegalHero";
import LegalContactCta from "@/pages/legal/components/LegalContactCta";
import AgeGuide from "@/pages/legal/minor-consent/components/AgeGuide";
import ConsentDocument from "@/pages/legal/minor-consent/components/ConsentDocument";
import VisitFlow from "@/pages/legal/minor-consent/components/VisitFlow";
import NotesList from "@/pages/legal/minor-consent/components/NotesList";
import MinorFaq from "@/pages/legal/minor-consent/components/MinorFaq";
import { legalPages } from "@/mocks/legalPages";

export default function MinorConsentPage() {
  const meta = legalPages.minorConsent;

  return (
    <>
      <LegalHero path={meta.path} en={meta.en} h1={meta.h1} lead={meta.lead} sub={meta.sub} />

      <AgeGuide />
      <ConsentDocument />
      <VisitFlow />
      <NotesList />
      <MinorFaq />

      <LegalContactCta
        heading="未成年の方の施術についてのご相談"
        note="未成年の方の施術や親権者同意書に関するご不明点は、お電話またはLINEよりお問い合わせください。"
      />
    </>
  );
}